

import {Vue, Component, Prop} from "vue-property-decorator";
import {deleteGroup, getGroups} from "@pazion/pazion-core/src/services/auth-service";
import PazClipboardButton from "@pazion/pazion-core/src/components/controls/PazClipboardButton.vue";
import EditGroupDialog from "@pazion/pazion-core/src/views/group/EditGroupDialog.vue";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import PazConfirmation from "@pazion/pazion-core/src/components/utils/PazConfirmation.vue";
import PazTextSearch from "@pazion/pazion-core/src/components/controls/PazTextSearch.vue";
import PazAjaxTable from "@pazion/pazion-core/src/components/layout/PazAjaxTable.vue";
import PazRefreshButton from "@pazion/pazion-core/src/components/controls/PazRefreshButton.vue";

@Component({
  components: {
    PazClipboardButton,
    EditGroupDialog,
    PazTooltipButton,
    PazConfirmation,
    PazTextSearch,
    PazAjaxTable,
    PazRefreshButton,
  },
})
export default class GroupList extends Vue {


  public loading: boolean = true;
  @Prop({default: ''})
  public search!: string;
  public items: object[] = [];
  public headers: object[] = [
    {
      text: "Id",
      align: "left",
      sortable: true,
      value: "id",
    },
    {
      text: "Name",
      align: "left",
      sortable: true,
      value: "name",
    },
    {
      text: "Active",
      align: "left",
      sortable: true,
      value: "isActive",
    },
    {
      text: "Created at",
      align: "left",
      sortable: true,
      value: "createdAt",
    },
    {
      text: "Changed at",
      align: "left",
      sortable: true,
      value: "changedAt",
    },
    {
      text: "Action",
      align: "right",
      sortable: true,
      value: "extra",
    },
  ];
  showEditDialog: boolean = false;
  selectedId: number | null = null;


  $refs!: {
    confirm: PazConfirmation;
    response: PazConfirmation;
    confirmWarn: PazConfirmation;
  };


  async fetchData() {
    this.loading = true;
    this.items = await getGroups();
    this.loading = false;
  }

  async confirmDeletion(group: any) {

    const confirm = await this.$refs.confirm.openConfirmDialog(
        "Delete",
        "Are you sure you want to delete `" + group.name + "`?"
    );
    if (confirm) {
      const response = await deleteGroup(group.id);
      if (response) await this.fetchData();
    }
  }

  triggerEditDialog(id: number | null, isClose: boolean) {
    this.selectedId = id;
    this.showEditDialog = !isClose;
  }
  async showDetails(id: number) {
    await this.$router.push({ path: `/groups/${id}` })
  }

  public mounted() {
    this.fetchData();
  }
}
